import { faPencil } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import TotalResumeLine from 'components/Checkout2/UI/TotalResumeLine';
import { Button } from 'components/UI';
import { FunctionComponent, ReactNode } from 'react';

export interface FooterProps {
    buttonLabel: string;
    total: number;
    loading?: boolean;
    disableButton?: boolean;
    className?: string;
    canEditPrice?: boolean;
    onEditPrice?: () => void;
    frequencyLabel?: string;
    note?: ReactNode;
    onClickButton?: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            height: '100%',
            width: '100%'
        },
        button: {
            height: 50,
            marginTop: 18
        },
        note: {
            marginTop: 16
        },
        editIcon: {
            marginLeft: 12,
            cursor: 'pointer',
            color: '#000'
        }
    })
);

export const Footer: FunctionComponent<FooterProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={classes.container}>
            <TotalResumeLine
                description="Total"
                value={`$${props.total.toFixed(2)}${props.frequencyLabel ? ` ${props.frequencyLabel}` : ''}`}
                action={
                    props.canEditPrice && (
                        <FontAwesomeIcon
                            icon={faPencil}
                            className={classes.editIcon}
                            onClick={props.onEditPrice}
                        />
                    )
                }
            />
            {props.note && <Box className={classes.note}>{props.note}</Box>}
            <Button
                label={props.buttonLabel}
                color="black"
                size="large"
                disabled={props.disableButton}
                loading={props.loading}
                className={classes.button}
                onClick={props.onClickButton}
            />
        </Box>
    );
};

export default Footer;
